export default __webpack_public_path__ + "static/media/regulatory--no-turns--g1.32fc69c3.png";